module.exports = __webpack_public_path__ + "img/C06TechRoyalGarden_ua.255da7a7.webp";